import _ from 'lodash'
import Backbone from 'backbone'
import template from './field-group-form.hbs'
import selects from 'scoreboard/components/selects'
import MarkedField from 'scoreboard/components/marked-field'
import FormView from 'scoreboard/components/form-view'
import requiredValidator from 'scoreboard/components/validators/required-validator'

var FieldGroupForm = Backbone.View.extend({

	tagName: 'form',

	className: 'field-group-form',

	/** @type {Dataset} */
	model: null,

	/**
	 * Creates the form that allows for editing dataset field groups (#12884)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the dataset
	 *
	 * @param {Object} options.group the current field group
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template(this.options))

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		let fieldsForGroup = this.model.getFieldsForGroup(this.options.group)
		let options = _(this.model.get('fields'))
			.orderBy(field => field.label.toLocaleUpperCase())
			.map(field => {
				let option = _.clone(field)
				option.label = _.escape(field.label)
				if (_.includes(fieldsForGroup, field)) {
					option.selected = true
				}
				return option
			})
			.value()
		selects.filtering(this.$('[name=fields]'), {
			options,
			multiple: true,
			accessors: { value: 'id' }
		})

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		}).start()

		return this
	},

	submit: function() {
		let newGroup = this.$('[name=label]').val()
		let newFields = this.$('[name=fields]').val()
		_.each(this.model.get('fields'), field => {
			if (_.includes(newFields, '' + field.id)) {
				field.group = newGroup
			} else if (field.group === this.options.group) {
				delete field.group
			}
		})
		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.labelField, this.formView], 'remove')
	}

})

export default FieldGroupForm

FieldGroupForm.__filename__ = 'datasets/edit/fields/field-group-form.js'
